import Lightbox from "react-image-lightbox"
import { Carousel as PCarousel } from "react-responsive-carousel";
import Image from "../CustomImage"
import { RenderCustomThumbs } from "./renderCustomThumbs"
import youtube_icon_red from '~/public/images/youtube_icon_red.inline.svg';
import zoomNew from '~/public/images/zoom-In.inline.svg'
import WishlistButton from "../WishlistButton/WishlistButton";

const ProductCarousalPDP = ({
    isOpen,
    zoomimgs,
    photoIndex,
    zoomopen,
    navigate,
    product,
    mediaList,
    isMobileType,
    zoomvideos,
    showYoutube,
    styles,
    pdp = false,
    childsku = 0,
    eventCommonObj = {},
    variantLabel = "",
    saleproductprice = 0,
    productSellPrice = 0,
}) => {
    return (
        <>
        {!pdp && isOpen ? (
                <Lightbox
                    mainSrc={zoomimgs[photoIndex]}
                    nextSrc={zoomimgs[(photoIndex + 1) % zoomimgs.length]}
                    prevSrc={zoomimgs[(photoIndex + zoomimgs.length - 1) % zoomimgs.length]}
                    onCloseRequest={() => zoomopen(false, 0)}
                    onMovePrevRequest={() => navigate((photoIndex + zoomimgs.length - 1) % zoomimgs.length)}
                    onMoveNextRequest={() => navigate((photoIndex + 1) % zoomimgs.length)}
                />
            ) : null}

            <div className={`col-12 col-md-6 p-col-0 ${styles.carousalReviewSec}`}>
                <div className={`productLayoutGallery gallery ${styles["gallery"]}`}>
                    {product && mediaList ? (
                        <PCarousel
                            showArrows
                            showStatus={false}
                            showIndicators
                            showThumbs
                            autoPlay={false}
                            transitionTime={500}
                            emulateTouch
                            swipeable
                            draggable
                            swipeScrollTolerance={5}
                            preventMovementUntilSwipeScrollTolerance
                            showDots={false}
                            renderThumbs={() => RenderCustomThumbs(mediaList, styles)}
                        >
                            {zoomimgs?.map((image, index) =>
                                <span key={index}>
                                    {!isMobileType && <a className="zoom-icon" onClick={() => zoomopen(true, index)}>
                                        <img priority={index == 0 || false} width={40} height={40} src={zoomNew} alt="zoom icon" />
                                    </a>}
                                    <Image
                                        className={styles.pdpBanner}
                                        onDoubleClick={() => zoomopen(true, index)}
                                        loading={index === 0 ? 'eager' : 'lazy'}
                                        width={600}
                                        height={600}
                                        src={image}
                                        alt={product.name} />
                                </span>
                            )}
                            {zoomvideos?.map((video, index) =>
                                <div key={index} className={styles.youtube_iframe} id={`youtube_${index}`}>
                                    <div className={styles.youtube_icon}>
                                        <img className={styles.youtube_icon_red} loading="lazy" width={45} height={32} src={youtube_icon_red} alt="youtube icon red icon" />
                                    </div>
                                    <div className={styles.youtube_iframe_img}>
                                        <Image
                                            loading='lazy'
                                            key={index}
                                            src={video?.url}
                                            width={640}
                                            height={480}
                                            alt={video.label}
                                            onClick={() => showYoutube(video?.video_content?.video_url, `youtube_${index}`)}
                                            placeholder="blur" blurDataURL="/images/kama-placeholder-kama.jpg" />
                                    </div>
                                </div>
                            )}
                        </PCarousel>
                    ) : (
                        ""
                    )}

                    {pdp && <div className={styles.icon_shoping}>
                        <ul>
                            <li className={styles.wishlist_box}>
                                <a>
                                    <WishlistButton
                                        product={product}
                                        name={product?.name}
                                        parentSku={product?.sku}
                                        sku={childsku}
                                        variantLabel={variantLabel}
                                        eventCommonObj={eventCommonObj}
                                        productprice={saleproductprice}
                                        productSellPrice={productSellPrice}
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>}
                </div>
            </div>
        </>
    )
}

export default ProductCarousalPDP